module.exports = __webpack_public_path__ + "img/driveline.f3ecc993.jpg";